import {environment} from '../environments/environment';

export const headerVersion = '0.0.0';
export const headerScriptDomId = 'ert-global-header-script';
export const publishAndWaitTimeout = 10000;
export const clientDomId = 'data-client-id';

export const headerConfig = {
    navigatorBaseUrl: environment.navigatorBaseUrl
};

export const headerDetails = {
    version: '2.8.0',
    buildNumber: '1848761524',
    buildDateTime: '2025-06-02T11:46:32+00:00',
    config: headerConfig
};

export enum PubSubMessages {
    // API calls, header.js -> host app
    logout = 'logout-call',
    setProductTitle = 'set-product-title-call',
    navigateToStudy = 'navigate-to-study-call',
    addStudyContextLink = 'add-study-context-link-call',
    clearCachedStudies = 'clear-cached-studies-call',
    setState = 'set-state-call',
    updateUserProfile = 'update-user-profile-call',
    addDropdown = 'add-dropdown-call',
    removeDropdown = 'remove-dropdown-call',
    cacheGetStudyByStudyNumber = 'cache-get-study-by-study-number-call',
    cacheGetStudy = 'cache-get-study-call',
    createState = 'create-state-call',
    createStateByStudyNumber = 'create-state-by-study-number-call',
    log = 'log-call',
    setBreadcrumbs = 'set-breadcrumbs-call',
    registerClientRoot = 'register-client-root-call',
    redirect = 'redirect-call',

    // SUB-API calls: Navigation Service
    navigationServiceNavigateTo = 'nav-svc-navigate-to-call',

    // data, header.js -> host app
    activityData = 'activity-data',
    urlChanged = 'url-changed-data',
    pageTitle = 'page-title-data',
    idTokenData = 'id-token-data',
    scriptData = 'script-data',
    productProvidedData = 'product-provided-data',

    // events, host app -> header.js
    logoutEvent = 'logout-event',
    sessionExpired = 'session-expired-event'
}
